/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_Categories_MiddlewareInputs */

const en_us2_technologies_categories_middleware = /** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middleware`)
};

const es_es2_technologies_categories_middleware = /** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middleware`)
};

const ru_technologies_categories_middleware = /** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промежуточное ПО`)
};

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const id_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const ms_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const da_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const de_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const es_mx2_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const fil_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const fr_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const it_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const hu_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const nl_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const no_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const pl_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const pt_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const pt_br2_technologies_categories_middleware = pt_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const ro_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const fi_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const sv_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const vi_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const tr_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const cs_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const bg_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const uk_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const ar_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const hi_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const th_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const ja_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const zh_cn2_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const zh_hant1_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/** @type {(inputs: Technologies_Categories_MiddlewareInputs) => LocalizedString} */
const ko_technologies_categories_middleware = en_us2_technologies_categories_middleware;

/**
* | output |
* | --- |
* | "Middleware" |
*
* @param {Technologies_Categories_MiddlewareInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_categories_middleware = /** @type {((inputs?: Technologies_Categories_MiddlewareInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Categories_MiddlewareInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_categories_middleware(inputs)
	if (locale === "ms") return ms_technologies_categories_middleware(inputs)
	if (locale === "da") return da_technologies_categories_middleware(inputs)
	if (locale === "de") return de_technologies_categories_middleware(inputs)
	if (locale === "en-US") return en_us2_technologies_categories_middleware(inputs)
	if (locale === "es-ES") return es_es2_technologies_categories_middleware(inputs)
	if (locale === "es-MX") return es_mx2_technologies_categories_middleware(inputs)
	if (locale === "fil") return fil_technologies_categories_middleware(inputs)
	if (locale === "fr") return fr_technologies_categories_middleware(inputs)
	if (locale === "it") return it_technologies_categories_middleware(inputs)
	if (locale === "hu") return hu_technologies_categories_middleware(inputs)
	if (locale === "nl") return nl_technologies_categories_middleware(inputs)
	if (locale === "no") return no_technologies_categories_middleware(inputs)
	if (locale === "pl") return pl_technologies_categories_middleware(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_categories_middleware(inputs)
	if (locale === "pt") return pt_technologies_categories_middleware(inputs)
	if (locale === "ro") return ro_technologies_categories_middleware(inputs)
	if (locale === "fi") return fi_technologies_categories_middleware(inputs)
	if (locale === "sv") return sv_technologies_categories_middleware(inputs)
	if (locale === "vi") return vi_technologies_categories_middleware(inputs)
	if (locale === "tr") return tr_technologies_categories_middleware(inputs)
	if (locale === "cs") return cs_technologies_categories_middleware(inputs)
	if (locale === "bg") return bg_technologies_categories_middleware(inputs)
	if (locale === "ru") return ru_technologies_categories_middleware(inputs)
	if (locale === "uk") return uk_technologies_categories_middleware(inputs)
	if (locale === "ar") return ar_technologies_categories_middleware(inputs)
	if (locale === "hi") return hi_technologies_categories_middleware(inputs)
	if (locale === "th") return th_technologies_categories_middleware(inputs)
	if (locale === "ja") return ja_technologies_categories_middleware(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_categories_middleware(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_categories_middleware(inputs)
	return ko_technologies_categories_middleware(inputs)
});
export { technologies_categories_middleware as "technologies.categories.middleware" }